import { useState } from 'react'
import { useChangePassword } from '../lib/admin'
import { useToast } from '../components/ToastContainer'

export default function AdminChangePassword() {
  const changePassword = useChangePassword()
  const { success: toastSuccess, error: toastError } = useToast()

  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorText, setErrorText] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorText('')

    if (newPassword !== confirmPassword) {
      setErrorText('As senhas não coincidem')
      return
    }

    if (newPassword.length < 6) {
      setErrorText('A senha deve ter pelo menos 6 caracteres')
      return
    }

    try {
      await changePassword.mutateAsync({ old_password: oldPassword, new_password: newPassword })
      setOldPassword('')
      setNewPassword('')
      setConfirmPassword('')
      toastSuccess('Senha alterada com sucesso!')
    } catch (err: unknown) {
      setErrorText((err as { response?: { data?: { detail?: string } } })?.response?.data?.detail ?? 'Erro ao alterar senha')
      toastError('Erro ao alterar senha')
    }
  }

  const isLoading = changePassword.isPending
  const isDisabled = isLoading || !oldPassword || !newPassword || !confirmPassword

  return (
    <div className="max-w-md space-y-6">
      <h2 className="text-xl font-bold text-[var(--color-text)]">Trocar Senha</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-sm space-y-4">
          <div>
            <label htmlFor="oldPassword" className="block text-sm font-medium text-[var(--color-text)]">
              Senha Atual
            </label>
            <input
              id="oldPassword"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Digite sua senha atual"
              className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
            />
          </div>

          <div>
            <label htmlFor="newPassword" className="block text-sm font-medium text-[var(--color-text)]">
              Nova Senha
            </label>
            <input
              id="newPassword"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
            />
          </div>

          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-[var(--color-text)]">
              Confirmar Nova Senha
            </label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repita a nova senha"
              className="mt-1 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-subtle)] px-3 py-2 text-sm text-[var(--color-text)] placeholder-[var(--color-text-muted)] focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]"
            />
          </div>

          {errorText && (
            <p className="text-sm text-[var(--color-danger)]">{errorText}</p>
          )}

          <button
            type="submit"
            disabled={isDisabled}
            className="w-full rounded-lg bg-[var(--color-danger)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--color-danger)] disabled:opacity-50"
          >
            {isLoading ? 'Alterando...' : 'Alterar Senha'}
          </button>
        </div>
      </form>
    </div>
  )
}
